module.exports = __webpack_public_path__ + "static/media/water1.4b3f27ce.jpg";